export default {
  created () {
    this.getScreenType()
    window.addEventListener('resize', this.getScreenType)
  },
  data () {
    return {
      screenType: 'desktop',
      screenWidth: 375
    }
  },
  methods: {
    getScreenType () {
      const screenWidth = window.innerWidth
      this.screenWidth = screenWidth
      if (screenWidth <= 768) {
        this.screenType = 'mobile'
      } else if (screenWidth <= 960 + 128) {
        this.screenType = 'tablet'
      } else if (screenWidth <= 1152 + 128) {
        this.screenType = 'desktop'
      } else if (screenWidth <= 1344 + 128) {
        this.screenType = 'widescreen'
      } else {
        this.screenType = 'fullhd'
      }
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.getScreenType)
  }
}
